import { LogOut, UserRound } from 'lucide-react';
import { useEffect, useRef, useState, type ReactNode } from 'react';
import { initialsOf } from '../lib/avatar';
import { href } from '../lib/router';

/**
 * Who is signed in, top right in both apps: their initials and name, and a menu with their account and
 * sign out under whatever the app puts first (an assessment to switch to, an organisation, …).
 */
export function AccountMenu({ name, org, onSignOut, children }: { name: string; org: string | null; onSignOut: () => void; children?: ReactNode }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => !ref.current?.contains(e.target as Node) && setOpen(false);
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  return (
    <div className="menu-wrap me-wrap" ref={ref}>
      <button type="button" className="me-btn" aria-label={`Account: ${name}`} aria-expanded={open} aria-haspopup="menu" onClick={() => setOpen((o) => !o)}>
        <span className="avatar" aria-hidden>{initialsOf(name)}</span>
        <span className="who" aria-hidden>
          <b>{name}</b>
          {org && <span>{org}</span>}
        </span>
      </button>
      {open && (
        <div className="menu right" role="menu" onClick={(e) => (e.target as HTMLElement).closest('.menu-item') && setOpen(false)}>
          {children}
          <a className="menu-item" role="menuitem" href={href.account()}>
            <UserRound size={14} /> Your account
          </a>
          <button type="button" className="menu-item" role="menuitem" onClick={onSignOut}>
            <LogOut size={14} /> Sign out
          </button>
        </div>
      )}
    </div>
  );
} // prettier-ignore
